import {
	getMciKrIdentifiersFromSkillsAndPlugins,
	type MciKrSkillInput,
} from './getMciKrIdentifiersFromSkillsAndPlugins';
import { mciKrAttributes, type MciKrAttributes } from './mciKrAttributes';

/**
 * The one entry point call sites should use: takes the turn's raw skills/plugins/agent data and
 * returns the KR eligibility attributes to spread into the analytics event's attributes object (or
 * `{}` if nothing matches). MCI KR enrichment is permanent, so callers do not need a feature-gate
 * check.
 */
export const mciKrAttributesFromSkillsAndPlugins = (
	skillsInvoked: MciKrSkillInput[],
	pluginsInvoked: Iterable<string>,
	agentExternalConfigReference?: string | null,
): MciKrAttributes =>
	mciKrAttributes(
		getMciKrIdentifiersFromSkillsAndPlugins(
			skillsInvoked,
			pluginsInvoked,
			agentExternalConfigReference,
		),
	);
